var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-items-edit',{attrs:{"content-type":"files","content-type-singular":"file","content-name":"Files","content-name-singular":"File"}})}
var staticRenderFns = []

export { render, staticRenderFns }